import request from 'superagent'
import url from '../../utils/url'

export const actionTypes = {
  AUTOMATED_REPORTS_REQUEST: 'AUTOMATED_REPORTS_REQUEST',
  AUTOMATED_REPORTS_SUCCESS: 'AUTOMATED_REPORTS_SUCCESS',
  AUTOMATED_REPORTS_ERROR: 'AUTOMATED_REPORTS_ERROR',
  REMOVE_AUTOMATED_REPORT_REQUEST: 'REMOVE_AUTOMATED_REPORT_REQUEST',
  REMOVE_AUTOMATED_REPORT_SUCCESS: 'REMOVE_AUTOMATED_REPORT_SUCCESS',
  REMOVE_AUTOMATED_REPORT_ERROR: 'REMOVE_AUTOMATED_REPORT_ERROR',
}

export const getAutomatedReports = () => function (dispatch) {
  dispatch({ type: actionTypes.AUTOMATED_REPORTS_REQUEST })

  return request
    .get(url('/localsearch/get-alerts'))
    .set('Content-Type', 'application/json')
    .then(
      ({ body = {} }) =>
        dispatch({
          type: actionTypes.AUTOMATED_REPORTS_SUCCESS,
          data: body,
        }),
      (error) =>
        dispatch({
          type: actionTypes.AUTOMATED_REPORTS_ERROR,
          error,
        })
    )
}

export const removeAutomatedReport = ({ id }) => function (dispatch) {
  dispatch({
    type: actionTypes.REMOVE_AUTOMATED_REPORT_REQUEST,
    data: { id },
  })

  return request
    .post(url('/localsearch/remove-alert'))
    .send({ id })
    .set('Content-Type', 'application/json')
    .then(
      ({ body = {} }) => {
        dispatch({
          type: actionTypes.REMOVE_AUTOMATED_REPORT_SUCCESS,
          data: body,
        })
        dispatch(getAutomatedReports())
      },
      (error) =>
        dispatch({
          type: actionTypes.REMOVE_AUTOMATED_REPORT_ERROR,
          error,
        })
    )
}


/** WEBPACK FOOTER **
 ** ./src/redux/actions/searchAlertsAction.js
 **/